'use client';

import { __awaiter, __generator } from '../../_virtual/_tslib.js';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import Cookies from 'js-cookie';

var INVALID_CUSTOM_TOKEN = 'auth/invalid-custom-token';
var FIREBASE_JWT_COOKIE_NAME = 'FIREBASE_JWT';
var VNW_WS_COOKIE = 'VNWWS128450527232960';
var FIREBASE_APP_NAME_VNW_MESSAGE = 'FIREBASE_VNW_MESSAGE';
var FireBaseService = /** @class */ (function () {
    function FireBaseService(config) {
        var _this = this;
        this.TAG = '[FireBaseService]';
        this.refreshJWT = function () { return __awaiter(_this, void 0, void 0, function () {
            var response, vnwWSCookie, responseData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        vnwWSCookie = Cookies.get(VNW_WS_COOKIE);
                        // Without VNW_WS_COOKIE then there is no need to call refresh JWT
                        if (!vnwWSCookie) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, fetch(this.refreshJWTUrl)];
                    case 1:
                        response = _a.sent();
                        if (!(response.status === 200)) return [3 /*break*/, 3];
                        return [4 /*yield*/, response.json()];
                    case 2:
                        responseData = _a.sent();
                        if (responseData.jwt) {
                            if (typeof window !== 'undefined') {
                                Cookies.set('FIREBASE_JWT', responseData.jwt, { expires: 90 });
                            }
                            return [2 /*return*/, Promise.resolve(responseData.jwt)];
                        }
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        _a.sent();
                        console.error('[Error Caught] refresh JWT', response);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/, null];
                }
            });
        }); };
        try {
            var firebaseApp = firebase.app(FIREBASE_APP_NAME_VNW_MESSAGE);
            this.firebase = firebaseApp;
        }
        catch (e) {
            console.debug(this.TAG, "will create a new instance of ".concat(FIREBASE_APP_NAME_VNW_MESSAGE, " "));
            this.firebase = firebase.initializeApp(config, FIREBASE_APP_NAME_VNW_MESSAGE);
        }
        this.refreshJWTUrl = config.refreshJWTUrl;
        this.refreshJWTRetry = 0;
        this.firstAuth = false;
    }
    FireBaseService.prototype._handleAuthFail = function (error) {
        return __awaiter(this, void 0, void 0, function () {
            var errorCode, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        errorCode = error.code;
                        console.error('Retry when firebase authentication failed', error);
                        return [4 /*yield*/, this.getAuth().signOut()];
                    case 1:
                        _a.sent();
                        if (!(errorCode === INVALID_CUSTOM_TOKEN)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.refreshJWT()];
                    case 2:
                        token = _a.sent();
                        if (token) {
                            this.refreshJWTRetry++;
                            return [2 /*return*/, this.authenticate(token)];
                        }
                        _a.label = 3;
                    case 3: return [2 /*return*/, undefined];
                }
            });
        });
    };
    FireBaseService.prototype.authenticate = function (token) {
        return __awaiter(this, void 0, void 0, function () {
            var err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 5]);
                        return [4 /*yield*/, this.getAuth().signInWithCustomToken(token)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        err_1 = _a.sent();
                        if (!(this.refreshJWTRetry < 3)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._handleAuthFail(err_1)];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        console.error('Firebase Authentication failed ' + this.refreshJWTRetry, err_1);
                        return [2 /*return*/, undefined];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    FireBaseService.prototype.authenticatedConnect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var jwtToken;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // for the first time authentication, always need to use JWT stored in cookie to verify the user
                        // otherwise firebase will recognise the previous logged in user base on session
                        if (!this.firstAuth) {
                            // check if firebase has already signed in
                            if (this.getAuth().currentUser) {
                                return [2 /*return*/, Promise.resolve(this.getAuth())];
                            }
                        }
                        jwtToken = Cookies.get(FIREBASE_JWT_COOKIE_NAME);
                        if (!!jwtToken) return [3 /*break*/, 2];
                        this.getAuth().signOut();
                        return [4 /*yield*/, this.refreshJWT()];
                    case 1:
                        jwtToken = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!jwtToken) {
                            console.log('Cannot authenticate firebase at the moment');
                            return [2 /*return*/, Promise.resolve()];
                        }
                        this.firstAuth = true;
                        return [2 /*return*/, this.authenticate(jwtToken)];
                }
            });
        });
    };
    FireBaseService.prototype.getAuth = function () {
        return this.firebase.auth();
    };
    FireBaseService.prototype.getDatabase = function () {
        return this.firebase.database();
    };
    FireBaseService.prototype.getUserId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currentUser;
            var _this = this;
            return __generator(this, function (_a) {
                currentUser = this.getAuth().currentUser;
                if (currentUser) {
                    return [2 /*return*/, Promise.resolve(currentUser.uid)];
                }
                else {
                    return [2 /*return*/, new Promise(function (resolve) {
                            _this.getAuth().onAuthStateChanged(function (user) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    if (user) {
                                        resolve(user.uid);
                                    }
                                    else {
                                        resolve(null);
                                    }
                                    return [2 /*return*/];
                                });
                            }); });
                        })];
                }
            });
        });
    };
    FireBaseService.prototype.signOut = function () {
        return this.getAuth().signOut();
    };
    return FireBaseService;
}());

export { FIREBASE_APP_NAME_VNW_MESSAGE, FireBaseService as default };
//# sourceMappingURL=FireBaseService.js.map
